import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ERTMedicalRunSheetService } from "../../../services/emergency-response/medical-runsheet.service";

@Component({
  selector: "app-ert-emergency-response-addmrs-additional-info",
  templateUrl: "./ert-emergency-response-addmrs-additional-info.component.html",
})
export class ErtEmergencyResponseAddmrsAdditionalInfoComponent
  implements OnInit
{
  emergencyResponseId: string;

  constructor(
    private route: ActivatedRoute,
    public ertMedicalRunSheetService: ERTMedicalRunSheetService  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.emergencyResponseId = params["emergencyResponseId"];
    });
  }
}
